// extracted by mini-css-extract-plugin
export default {"galaxyBackground":"GalaxyBackground_galaxyBackground__s6Rs4"};